import Button from "components/components/Button/Button";
import FullWidthSection from "components/components/FullWidthSection/FullWidthSection";
import { fullWidthStyles } from "components/components/FullWidthSection/style";
import styled from "styled-components";
import colours from "styles/colours";

export const Wrapper = styled.div`
  &&,
  && h2 {
    color: white;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TextContainer = styled.div`
  width: 70%;
  margin-right: 10%;
`;

export const FeedbackButton = styled(Button)`
  &&& {
    font-weight: bold;
  }
`;

export const StyledFullWidthSection = styled(FullWidthSection)`
  background: ${colours.elexonPurple};
  ${fullWidthStyles};
`;
